'use strict';

// v = 2.0

import dispatcher from '../dispatcher';
import loaderStore from './loader.store';
import History from './history.class';
import {http} from '../utils';

const HTML = document.documentElement;
let initHost = window.location.host;
let currentHref = window.location.href;

const items = {};
let idName = 'link-id-';
let idNum  = 1;


function _add(link) {
  if (link.classList.contains('lang-link') ||
      link.classList.contains('no-ajax') ||
      link.hasAttribute('download') ||
      link.getAttribute('target') === '_blank' ||
      link.host !== initHost) return;


  const obj = {
    id: idName + idNum,
    element: link,
    active: false,
    href: link.href || link.dataset.href,
    type: false,
    check: _checkHref
  };

  idNum++;

  obj.check();

  link.addEventListener('click', (e) => {
    e.preventDefault();

    if (e.ctrlKey || e.metaKey) {
      window.open(obj.href, '_blank');
      return;
    }

    _handleChange(obj);
  }, false);

  items[obj.id] = obj;
}

function _checkHref() {
  if (this.href === currentHref) {
    if (!this.active) this.element.classList.add('active');
    this.active = true;
  } else {
    if (this.active) this.element.classList.remove('active');
    this.active = false;
  }
}



function _handleChange(obj) {
  if (!loaderStore.getData().loaded || obj.active || !obj.href) return;

  dispatcher.dispatch({
    type:           'load-start',
    _module:        'router.view',
    content:        null,
    href:           obj.href,
    history:        obj.history,
    transitionType: obj.type
  // }, {
  //   type:           'router-emit',
  //   _module:        'router.view',
  //   route:          obj.href
  });

  http({
    action: obj.href,
    type: 'text'
  })
    .then(_handleCallback)
    .catch(reason => console.log(reason));
}


function _handleCallback(e = null) {
  dispatcher.dispatch({
    type:    'load-end',
    _module: 'router.view',
    content: e
  });
}



function _handleMutate() {
  let elements = document.querySelectorAll('a');

  currentHref = window.location.href;

  for (let i = 0; elements.length > i; i++) {
    check(elements[i])
  }
  for (let id in items) {
    if (items.hasOwnProperty(id)) backCheck(id);
  }

  function check(el) {
    for (let id in items) {
      if (items.hasOwnProperty(id) && items[id].element === el) return;
    }
    _add(el);
  }

  function backCheck(id) {
    for (let i = 0; elements.length > i; i++) {
      if (items[id].element === elements[i]) {
        items[id].check();
        return;
      }
    }
    delete items[id];
  }
}


function init() {
  if (HTML.classList.contains('bx-core')) {
    console.warn('The router is not running in the admin panel, because the bitrix is evil');
    return;
  }

  _handleMutate();
  _handleCallback();

  dispatcher.subscribe((e) => {
    if (e.type === 'mutate') _handleMutate();
    if (e.type === 'route-add') _add(e.element);
    if (e.type === 'route-change') {
      let link = document.createElement('a');
      link.href = e.route.href;

      if (link.host === initHost) {
        _handleChange(e.route);
      } else {
        window.open(e.route.href, '_blank');
      }
    }
  });

  History.addListener((state) => _handleChange({href: state.href, history: true}));
}


export default {
  init: init
}